import {
    Button,
    Typography
}                       from "@mui/material";
import {
    useEffect,
    useRef
}                       from "react";
import {
    AddCadastralInfoCommand,
    Cadastral,
    CadastralDetail,
    UpdateCadastralInfoCommand
}                       from "../constants";
import {useGBESContext} from "../context/GBESContextProvider";
import {submitObject}   from "../util";

const CadastralForm = () =>
{
    const {energyDetails, setModalVisible, formData, companyDetails, setRefreshResource, setAlertVisible, setAlertText} = useGBESContext()

    //<editor-fold desc="Changeable Variables">
    const AddTitle = "Kadastrale gegevens toevoegen"
    const EditTile = "Kadastrale gegevens bewerken"

    const AddForm = "GBE_AddCadastralInfo"
    const UpdateForm = "GBE_UpdateCadastralInfo"

    const AggregateDetails = companyDetails
    const ExtraFormData = formData
    const SubmitButton = "Submit"

    const DetailRefresh = CadastralDetail
    const MasterRefresh = Cadastral

    const AddCommand = AddCadastralInfoCommand
    const UpdateCommand = UpdateCadastralInfoCommand

    console.log(energyDetails.id)
    useEffect(() =>
    {
        if (FormRef.current !== undefined && energyDetails !== undefined)
        {
            FormRef.current.data = {
                systemId: energyDetails.id,
                ...ExtraFormData,
            }
        }
    }, []);
    //</editor-fold>

    //<editor-fold desc="Form - Does not need changing">
    const FormRef = useRef<any>()

    async function HandleSubmit(event: any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status === 200)
        {
            //If everything went okay we can close it
            setModalVisible(false)
            setAlertVisible(false)
        }
        else
        {
            let response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }

    }

    function onClickSubmit()
    {
        let Data: any = {}
        // @ts-ignore
        FormRef.current.getData().then((event: any) => Data = event)
        // @ts-ignore
        FormRef.current.submitForm().then(() =>
            {
                console.log(Data)
                if (formData === undefined)
                {
                    submitObject(Data, AggregateDetails?.id, AddCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event)
                    })
                    setRefreshResource(MasterRefresh)

                }
                else
                {
                    submitObject(Data, AggregateDetails?.id, UpdateCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event)
                    })
                    setRefreshResource(DetailRefresh)

                }
            }
        )

    }

    return (<>

        <Typography id="modal-modal-title" variant="h6" component="h2">
            {ExtraFormData === undefined
             ? AddTitle
             : EditTile}
        </Typography>
        {/*// @ts-ignore*/}

        {ExtraFormData === undefined
            // @ts-ignore
         ? <ig-form ref={FormRef} form-id={AddForm}/>
            // @ts-ignore
         : <ig-form ref={FormRef} form-id={UpdateForm}/>}
        <Button variant="contained" onClick={onClickSubmit}>{SubmitButton}</Button>
    </>)
    //</editor-fold>

}
export default CadastralForm